import { render, staticRenderFns } from "./GpsStops.vue?vue&type=template&id=56d5ed00&"
import script from "./GpsStops.vue?vue&type=script&lang=js&"
export * from "./GpsStops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d5ed00')) {
      api.createRecord('56d5ed00', component.options)
    } else {
      api.reload('56d5ed00', component.options)
    }
    module.hot.accept("./GpsStops.vue?vue&type=template&id=56d5ed00&", function () {
      api.rerender('56d5ed00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/gps/GpsStops.vue"
export default component.exports